<ng-container *transloco="let fieldTranslation; read: 'field-types'">
    <div
        class="w-120 flex flex-col border rounded-sm border-white border-dashed"
        [ngClass]="{ 'hover:border-green-300': draggingField == undefined }"
        cdkDrag
        [cdkDragData]="field"
        *ngIf="editable"
        (cdkDragStarted)="dragStarted()"
        (cdkDragEnded)="dragEnded()"
        cdkDragHandle
    >
        <div class="flex flex-row w-full px-2 py-3">
            <div class="flex items-center content-center">
                <mat-icon [svgIcon]="field.icon"></mat-icon>
            </div>

            <div class="flex flex-auto px-2 w-full items-center content-center">
                <span>{{ field.label }}</span>
                <span *ngIf="field.required" class="w-4 text-center text-red-700">*</span>
            </div>

            <button mat-icon-button (click)="edit()">
                <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="fieldOptionsMenu">
                <mat-icon svgIcon="heroicons_outline:dots-vertical"></mat-icon>
            </button>
        </div>

        <ng-template #content></ng-template>

        <mat-menu #fieldOptionsMenu="matMenu">
            <button mat-menu-item (click)="edit()">Editar</button>
            <button mat-menu-item (click)="duplicate()">Duplicar campo</button>
            <button mat-menu-item (click)="delete()">Excluir</button>
        </mat-menu>

        <div
            *cdkDragPlaceholder
            class="w-120 flex flex-row px-2 py-3 ring-1 ring-gray-200 rounded-sm bg-gray-50 shadow"
        >
            <mat-icon [svgIcon]="field.icon"></mat-icon>
            <div class="flex flex-auto px-2 w-full items-center content-center">
                <span>{{ field.label }}</span>
            </div>
        </div>

        <div *cdkDragPreview class="w-120 flex flex-row px-2 py-3 border rounded-sm border-dashed border-green-300">
            <mat-icon [svgIcon]="field.icon"></mat-icon>
            <div class="flex flex-auto px-2 w-full items-center content-center">
                <span>{{ field.label }}</span>
            </div>
        </div>
    </div>

    <div class="w-120 flex flex-col" *ngIf="!editable">
        <div class="flex flex-row w-full px-2 py-3">
            <div class="flex items-center content-center">
                <mat-icon [svgIcon]="field.icon"></mat-icon>
            </div>

            <div class="flex flex-auto px-2 w-full items-center content-center">
                <span>{{ field.label }}</span>
                <span *ngIf="field.required" class="w-4 text-center text-red-700">*</span>
            </div>
        </div>

        <ng-template #content></ng-template>
    </div>
</ng-container>
